var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLampStreet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352 227.439V128C352 57.422 294.594 0 224 0H128C57.406 0 0 57.422 0 128V512H64V128C64 92.703 92.719 64 128 64H224C259.281 64 288 92.703 288 128V227.453C205.252 241.23 140.02 306.215 128.219 388.906C126.25 403.25 137.875 416 152.406 416H487.594C502.125 416 513.75 403.25 511.781 388.906C499.979 306.193 434.773 241.197 352 227.439ZM320.041 512C355.416 512 384.041 483.375 384.041 448H256.041C256.041 483.375 284.666 512 320.041 512Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampStreet);
export default __webpack_public_path__ + "static/media/lamp-street.06d5a5e2ca9517bca4625aa6dbbd11be.svg";
export { ForwardRef as ReactComponent };